import { Module } from "vuex";

import { IRootState } from "@/store";
import { state } from "@/store/modules/transferAuthority/state";
import { getters } from "@/store/modules/transferAuthority/getters";
import { actions } from "@/store/modules/transferAuthority/actions";
import { mutations } from "@/store/modules/transferAuthority/mutations";
import { ITransferAuthorityState } from "@/store/modules/transferAuthority/state";

export const transferAuthority: Module<ITransferAuthorityState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
